import React from 'react'
import Fieldset from './Fieldset'
import { Text } from 'library/atoms/Typography'
import { Formik } from 'formik'
import { Code } from 'shared/library/molecules/EmbedCode'
import Flex from 'shared/library/atoms/Flex'
import Input from 'library/atoms/Input'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const PROPS = {
  Description: () => (
    <Text as="div">
      <p>
        The <Code>{`<fieldset>`}</Code> element is a convenient way to create
        groups of widgets that share the same purpose, for styling and semantic
        purposes.
      </p>
      <p>
        You can label the <Code>{`<fieldset>`}</Code> by using the legend
        attribute or including a <Code>{`<legend>`}</Code> element just below
        the opening <Code>{`<Fieldset>`}</Code> tag.
      </p>
    </Text>
  ),
  examples: [
    {
      title: 'Fieldset',
      code: `<Formik
  initialValues={{
    fullName: '',
    phoneNumber: '',
    cardholderName: '',
    cardNumber: ''
  }}
  onSubmit={() => {}}
>
  <Flex flexDirection="column" width={1}>

    <Fieldset legend="Contact details">
      <Input placeholder="Full name" name={'fullName'} />
      <Input placeholder="Phone Number" name={'phoneNumber'} />
    </Fieldset>

    <Fieldset legend="Payment details">
      <Input placeholder="Cardholder Name" name={'cardholderName'} />
      <Input placeholder="Card Number" name={'cardNumber'} />
    </Fieldset>

  </Flex>
</Formik>`,
      scope: { Formik, Fieldset, Flex, Input }
    }
  ]
}

const FieldsetStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default FieldsetStyleGuide
